import React from 'react';
import axios from 'axios';
import {Table, Modal, Button} from 'semantic-ui-react';
import {NoData} from "../../components/table/no-data";
import SupplierDetailsContainer from "./supplier-details-container";
import Currency from "../../components/formatters/currency";
import FormattedDate from "../../components/formatters/formattedDate";
import { apiUrl } from "../../config.js"


class SupplierTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    downloadDocument = (supplierInvoiceKey) => {
         
        axios({
            url: `${apiUrl}/SupplierInvoices/DownloadInvoice/${supplierInvoiceKey}`,
            method: 'POST',       // Worked using POST or PUT. Prefer POST
            headers : {
                'Authorization': `bearer ${localStorage.getItem("token")}`
             },
            responseType: 'blob', // important
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', supplierInvoiceKey + '.pdf');
            document.body.appendChild(link);
            link.click();
          });
    }

    render() {
        const { data, contextData } = this.props;
        const { updateSupplyOverride } = contextData;
        const { updateSupplierOverride } = contextData;
        const { updateFilterValue } = contextData;

        return (       
            <Table.Row>
                <Table.Cell 
        onClick={() => updateSupplyOverride && updateSupplyOverride(data.utility)}
      >{this.props.data.utility || <NoData/>}</Table.Cell>
                <Table.Cell
        onClick={() => updateFilterValue && updateFilterValue(data.supplierReference)}
      >{this.props.data.supplierReference || <NoData/>}</Table.Cell>
                <Table.Cell>{this.props.data.invoiceType || <NoData/>}</Table.Cell>
                <Table.Cell>{this.props.data.billingFrequency || <NoData/>}</Table.Cell>
                <Table.Cell>{this.props.data.dateFrom ? <FormattedDate value={this.props.data.dateFrom} inputFormat="YYYY-MM-DDThh:mm:ss"/> : <NoData/>}</Table.Cell>
                <Table.Cell>{this.props.data.dateTo ? <FormattedDate value={this.props.data.dateTo} inputFormat="YYYY-MM-DDThh:mm:ss"/> : <NoData/>}</Table.Cell>
                <Table.Cell
        onClick={() => updateSupplierOverride && updateSupplierOverride(data.supplier)}
      >{this.props.data.supplier || <NoData/>}</Table.Cell>
                <Table.Cell>{this.props.data.units || <NoData/>}</Table.Cell>
                <Table.Cell>{this.props.data.nett ? <Currency value={this.props.data.nett}/> : <NoData/>}</Table.Cell>
                <Table.Cell>{this.props.data.gross ? <Currency value={this.props.data.gross}/> : <NoData/>}</Table.Cell>
                <Table.Cell>
                    <Modal size="large" trigger={<Button basic>Invoice Detail</Button>} centered={false} closeIcon>
                        <Modal.Header><h2>{this.props.data.supplier} - {this.props.data.supplierReference}</h2></Modal.Header>
                        <Modal.Content>
                            <SupplierDetailsContainer supplierInvoiceKey={this.props.data.supplierInvKey} customerId={this.props.contextData.customerId} />
                        </Modal.Content>
                    </Modal>
                </Table.Cell>
                <Table.Cell>
                { (this.props.data.scannedFilePath  !== "" && this.props.data.scannedFilePath !== null)  &&
                 <Button icon='download'onClick={() => this.downloadDocument(this.props.data.supplierInvKey)}  color='green'></Button>
                }</Table.Cell>
            </Table.Row>
        );
    }
}

export default SupplierTableRow;